export interface ModalController {
  show: () => void
  hide: () => void
  toggle: () => void
}

const modals = new Map<string, ModalController[]>()
const pendingState = new Map<string, boolean>()
const hiddenListeners = new Set<(id: string) => void>()

const getModal = (id: string) => {
  const controllers = modals.get(id)
  return controllers?.[controllers.length - 1]
}

export const emitModalHidden = (id: string) => {
  if (!id) return
  hiddenListeners.forEach((listener) => listener(id))
}

export const onModalHidden = (listener: (id: string) => void) => {
  hiddenListeners.add(listener)
  return () => hiddenListeners.delete(listener)
}

export const registerModal = (id: string, controller: ModalController) => {
  if (!id) return
  const controllers = modals.get(id) || []
  const registered = controllers.filter((item) => item !== controller)
  registered.push(controller)
  modals.set(id, registered)
  if (!pendingState.has(id)) return
  const shouldShow = pendingState.get(id)
  pendingState.delete(id)
  shouldShow ? controller.show() : controller.hide()
}

export const unregisterModal = (id: string, controller: ModalController) => {
  if (!id) return
  const controllers = modals.get(id)
  if (!controllers) return

  const registered = controllers.filter((item) => item !== controller)
  if (registered.length > 0) modals.set(id, registered)
  else modals.delete(id)
}

export const modalService = {
  show(id: string) {
    const modal = getModal(id)
    if (modal) modal.show()
    else pendingState.set(id, true)
  },
  hide(id: string) {
    const modal = getModal(id)
    if (modal) modal.hide()
    else pendingState.set(id, false)
  },
  toggle(id: string) {
    getModal(id)?.toggle()
  }
}
